// ActionButton.tsx
import React from "react";
import { ActionButtonProps } from "./ActionButton.types";
import { ActionButtonWrapper } from "./ActionButton.styles";
import { Body5MediumTypography } from "../../primitives/Typography/typographyVariants";
import { Icon } from "../Icon/Icon";
import Box from "../../primitives/Box/Box";
import { colorPalette } from "../../theme/colors";

export const ActionButton = (props: ActionButtonProps) => {
  const hasIcon = !!props.leftIcon || !!props.rightIcon;
  // Handle quantity variant separately
  if (props.variant === "quantity") {
    const {
      quantity = 1,
      onIncrement,
      onDecrement,
      minQuantity = 0,
      maxQuantity = 99,
      disabled,
      dataCy,
    } = props;

    const isDecrementDisabled = disabled || quantity <= minQuantity;
    const isIncrementDisabled = disabled || quantity >= maxQuantity;
    const handleDecrement = () => {
      if (!isDecrementDisabled && onDecrement) {
        onDecrement();
      }
    };

    const handleIncrement = () => {
      if (!isIncrementDisabled && onIncrement) {
        onIncrement();
      }
    };

    return (
      <ActionButtonWrapper variant="quantity" hasIcon={true} data-cy={dataCy}>
        <Box
          display="flex"
          alignItems="center"
          p="4px"
          height="28px"
          width="28px"
          justifyContent="center"
        >
          <Icon
            onClick={handleDecrement}
            height="20px"
            width="20px"
            size="14px"
            name="fa-sharp fa-solid fa-minus"
            color={colorPalette.popWhite[500]}
            cursor={isDecrementDisabled ? "" : "pointer"}
            dataCy={`${dataCy}-decrement`}
          />
        </Box>
        <Body5MediumTypography>{quantity}</Body5MediumTypography>
        <Box
          display="flex"
          alignItems="center"
          p="4px"
          height="28px"
          width="28px"
          justifyContent="center"
        >
          <Icon
            onClick={handleIncrement}
            height="20px"
            width="20px"
            size="14px"
            name="fa-sharp fa-solid fa-plus"
            color={colorPalette.popWhite[500]}
            cursor={isIncrementDisabled ? "" : "pointer"}
            dataCy={`${dataCy}-increment`}
          />
        </Box>
      </ActionButtonWrapper>
    );
  }
  return (
    <ActionButtonWrapper {...props} hasIcon={hasIcon} data-cy={props.dataCy}>
      {props.leftIcon}
      <Body5MediumTypography>{props.children}</Body5MediumTypography>
      {props.rightIcon}
    </ActionButtonWrapper>
  );
};
